import productitem1 from "src/assets/images/productitem1.svg"
import productitem2 from "src/assets/images/productitem2.svg"
import productitem3 from "src/assets/images/productitem3.svg"
import productitem4 from "src/assets/images/productitem4.svg"

import Dome from "src/assets/images/products/AIView_Dome.png"
import Bullet from "src/assets/images/products/AIView_Bullet.png"
import PTZ from "src/assets/images/products/AIView_PTZ.png"
import AIBox from "src/assets/images/products/AIView_AIBox.png"
import Bphone1 from "src/assets/images/products/bphone1.png"
import Bphone2 from "src/assets/images/products/bphone2.png"
import Bphone3 from "src/assets/images/products/bphone3.png"
import feature1 from "src/assets/images/products/feature1.png"
import feature2 from "src/assets/images/products/feature2.png"
import feature3 from "src/assets/images/products/feature3.png"
import feature4 from "src/assets/images/products/feature4.png"
import feature5 from "src/assets/images/products/feature5.png"
import feature6 from "src/assets/images/products/feature6.png"
import feature7 from "src/assets/images/products/feature7.png"
import feature8 from "src/assets/images/products/feature8.png"

export const categories = [
  {
    id: 1,
    title: "Dome Camera",
    image: Dome,
    description:
      "Dome Camera là một dòng camera giám sát có thiết kế dạng bán cầu, thường được sử dụng trong nhà và ngoài trời nhờ khả năng chống bụi, chống nước và chống phá hoại. Với thiết kế nhỏ gọn và thẩm mỹ, Dome Camera dễ dàng hòa hợp với không gian lắp đặt, giúp hạn chế sự chú ý của người quan sát. Dòng camera này thường được trang bị các công nghệ hiện đại như cảm biến độ phân giải cao, hồng ngoại quan sát ban đêm, chống ngược sáng và đặc biệt là trí tuệ nhân tạo (AI) để nhận diện khuôn mặt, phát hiện xâm nhập hay đếm người. Nhờ góc quan sát rộng và khả năng xoay linh hoạt, Dome Camera là giải pháp lý tưởng cho các khu vực như văn phòng, trung tâm thương mại, khách sạn, nhà xưởng hay khu dân cư, đảm bảo an ninh hiệu quả và thông minh.",
  },
  {
    id: 2,
    title: "Bullet Camera",
    image: Bullet,
    description:
      "Bullet Camera là một dòng camera giám sát có thiết kế dạng bán cầu, thường được sử dụng trong nhà và ngoài trời nhờ khả năng chống bụi, chống nước và chống phá hoại. Với thiết kế nhỏ gọn và thẩm mỹ, Dome Camera dễ dàng hòa hợp với không gian lắp đặt, giúp hạn chế sự chú ý của người quan sát. Dòng camera này thường được trang bị các công nghệ hiện đại như cảm biến độ phân giải cao, hồng ngoại quan sát ban đêm, chống ngược sáng và đặc biệt là trí tuệ nhân tạo (AI) để nhận diện khuôn mặt, phát hiện xâm nhập hay đếm người. Nhờ góc quan sát rộng và khả năng xoay linh hoạt, Dome Camera là giải pháp lý tưởng cho các khu vực như văn phòng, trung tâm thương mại, khách sạn, nhà xưởng hay khu dân cư, đảm bảo an ninh hiệu quả và thông minh.",
  },
  {
    id: 3,
    title: "PTZ Camera",
    image: PTZ,
    description:
      "PTZ Camera là một dòng camera giám sát có thiết kế dạng bán cầu, thường được sử dụng trong nhà và ngoài trời nhờ khả năng chống bụi, chống nước và chống phá hoại. Với thiết kế nhỏ gọn và thẩm mỹ, Dome Camera dễ dàng hòa hợp với không gian lắp đặt, giúp hạn chế sự chú ý của người quan sát. Dòng camera này thường được trang bị các công nghệ hiện đại như cảm biến độ phân giải cao, hồng ngoại quan sát ban đêm, chống ngược sáng và đặc biệt là trí tuệ nhân tạo (AI) để nhận diện khuôn mặt, phát hiện xâm nhập hay đếm người. Nhờ góc quan sát rộng và khả năng xoay linh hoạt, Dome Camera là giải pháp lý tưởng cho các khu vực như văn phòng, trung tâm thương mại, khách sạn, nhà xưởng hay khu dân cư, đảm bảo an ninh hiệu quả và thông minh.",
  },
  {
    id: 4,
    title: "AI Box",
    image: AIBox,
    description:
      "AI Box là một dòng camera giám sát có thiết kế dạng bán cầu, thường được sử dụng trong nhà và ngoài trời nhờ khả năng chống bụi, chống nước và chống phá hoại. Với thiết kế nhỏ gọn và thẩm mỹ, Dome Camera dễ dàng hòa hợp với không gian lắp đặt, giúp hạn chế sự chú ý của người quan sát. Dòng camera này thường được trang bị các công nghệ hiện đại như cảm biến độ phân giải cao, hồng ngoại quan sát ban đêm, chống ngược sáng và đặc biệt là trí tuệ nhân tạo (AI) để nhận diện khuôn mặt, phát hiện xâm nhập hay đếm người. Nhờ góc quan sát rộng và khả năng xoay linh hoạt, Dome Camera là giải pháp lý tưởng cho các khu vực như văn phòng, trung tâm thương mại, khách sạn, nhà xưởng hay khu dân cư, đảm bảo an ninh hiệu quả và thông minh.",
  },
  {
    id: 5,
    title: "Bphone",
    image: Bphone1,
    description:
      "Camera AI - Nâng tầm nhiếp ảnh điện toán. Bộ 4 camera chính kết hợp cùng các sáng tạo công nghệ nhiếp ảnh điện toán nổi bật: Chụp Smacro với độ nét cao, chụp đêm sNight, chụp chân dung xóa phông, chụp góc rộng… cho hình ảnh trung thực, sắc nét",
  },
]

export const allProducts = [
  {
    id: 1,
    images: [
      productitem1,
      productitem2,
      productitem3,
      productitem4,
      feature1,
      feature2,
      feature3,
    ],
    categoryId: 1,
    detailId: 1,
    productTypeId: 1,
    title: "Camera AI View C100",
    description: "Camera an ninh giám sát AI View C300 2MP IR Dome Wifi VN",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 1234,
  },
  {
    id: 2,
    images: [productitem2, productitem1, productitem3],
    categoryId: 2,
    detailId: 2,
    productTypeId: 1,
    title: "Camera AI View S500",
    description: "Camera an ninh giám sát AI View S500 2MP 33X IR PTZ VN",
    reviews: [
      { rating: 4, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 156,
  },
  {
    id: 3,
    images: [productitem3, productitem1, productitem2],
    categoryId: 1,
    detailId: 3,
    productTypeId: 1,
    title: "AI View B1201 - 0802N",
    description: "Trong nhà ngoài trời",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 134,
  },
  {
    id: 4,
    images: [productitem4, productitem2, productitem3],
    categoryId: 1,
    detailId: 4,
    productTypeId: 1,
    title: "AI View B1201 - 0802N",
    description: "Trong nhà ngoài trời",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 12445,
  },
  {
    id: 5,
    images: [productitem1, productitem2, productitem3, productitem4],
    categoryId: 3,
    detailId: 5,
    productTypeId: 1,
    title: "Camera AI View C100",
    description: "Camera an ninh giám sát AI View C300 2MP IR Dome Wifi VN",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 80,
  },
  {
    id: 6,
    images: [productitem2, productitem3, productitem4],
    categoryId: 4,
    detailId: 6,
    productTypeId: 1,
    title: "Camera AI View S500 ",
    description: "Camera an ninh giám sát AI View S500 2MP 33X IR PTZ VN",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 1235,
  },
  {
    id: 7,
    images: [productitem2, productitem1, productitem4],
    categoryId: 3,
    detailId: 7,
    productTypeId: 1,
    title: "AI View B1201 - 0802N",
    description: "Trong nhà ngoài trời",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 123,
  },
  {
    id: 8,
    images: [productitem4, productitem1, productitem3],
    categoryId: 2,
    detailId: 8,
    productTypeId: 1,
    title: "AI View B1201 - 0802N",
    description: "Trong nhà ngoài trời",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 121,
  },
  {
    id: 9,
    images: [productitem1, productitem2, productitem4],
    categoryId: 1,
    detailId: 9,
    productTypeId: 1,
    title: "Camera AI View C100",
    description: "Camera an ninh giám sát AI View C300 2MP IR Dome Wifi VN",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 128,
  },
  {
    id: 10,
    images: [productitem4, productitem2, productitem3, productitem1],
    categoryId: 2,
    detailId: 10,
    productTypeId: 1,
    title: "Camera AI View S500",
    description: "Camera an ninh giám sát AI View S500 2MP 33X IR PTZ VN",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 132,
  },
  {
    id: 11,
    images: [productitem1, productitem2, productitem3, productitem4],
    categoryId: 3,
    detailId: 11,
    productTypeId: 1,
    title: "AI View B1201 - 0802N",
    description: "Trong nhà ngoài trời",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 153,
  },
  {
    id: 12,
    images: [productitem3, productitem4, productitem2, productitem1],
    categoryId: 3,
    detailId: 12,
    productTypeId: 1,
    title: "AI View B1201 - 0802N",
    description: "Trong nhà ngoài trời",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 193,
  },
  {
    id: 13,
    images: [productitem1, productitem2, productitem3, productitem4],
    categoryId: 4,
    detailId: 13,
    productTypeId: 1,
    title: "Camera AI View S500 ",
    description: "Camera an ninh giám sát AI View S500 2MP 33X IR PTZ VN",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 1235,
  },
  {
    id: 14,
    images: [productitem3, productitem4, productitem2, productitem1],
    categoryId: 1,
    detailId: 14,
    productTypeId: 1,
    title: "AI View B1201 - 0802N",
    description: "Trong nhà ngoài trời",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 123,
  },
  {
    id: 15,
    images: [productitem2, productitem4, productitem3, productitem1],
    categoryId: 2,
    detailId: 15,
    productTypeId: 1,
    title: "AI View B1201 - 0802N",
    description: "Trong nhà ngoài trời",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 121,
  },
  {
    id: 16,
    images: [productitem3, productitem4, productitem2, productitem1],
    categoryId: 4,
    detailId: 16,
    productTypeId: 1,
    title: "Camera AI View C100",
    description: "Camera an ninh giám sát AI View C300 2MP IR Dome Wifi VN",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 128,
  },
  {
    id: 17,
    images: [productitem1, productitem3, productitem4, productitem2, feature1],
    categoryId: 3,
    detailId: 17,
    productTypeId: 1,
    title: "Camera AI View S500",
    description: "Camera an ninh giám sát AI View S500 2MP 33X IR PTZ VN",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 132,
  },
  {
    id: 18,
    images: [
      productitem4,
      productitem2,
      productitem3,
      productitem1,
      feature1,
      feature2,
      feature3,
    ],
    categoryId: 2,
    detailId: 18,
    productTypeId: 1,
    title: "AI View B1201 - 0802N",
    description: "Trong nhà ngoài trời",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
      { rating: 4, comment: "Sản phẩm rất tốt!" },
      { rating: 4, comment: "Tuyệt vời!" },
      { rating: 4, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 153,
  },
  {
    id: 19,
    images: [
      Bphone1,
      Bphone2,
      Bphone3,
    ],
    categoryId: 5,
    detailId: 18,
    productTypeId: 2,
    title: "Bphone A85 5G",
    description: "Điện thoại thông minh",
    reviews: [
      { rating: 5, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
      { rating: 4, comment: "Sản phẩm rất tốt!" },
      { rating: 4, comment: "Tuyệt vời!" },
      { rating: 4, comment: "Sản phẩm rất tốt!" },
      { rating: 5, comment: "Tuyệt vời!" },
    ],
    price: 0,
    inStock: 1000,
    sale: 0,
    sold: 153,
  },
]

export const detailProducts = [
  {
    id: 1,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 2,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 3,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 4,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 5,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 6,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 7,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 8,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 9,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 10,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 11,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 12,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 13,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 14,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 15,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 16,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 17,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    id: 18,
    title: "Tổng quan",
    overview: [
      "Camera AI View với bộ giải pháp trí tuệ nhân tạo Gloria AI Edge Box sử dụng chip tăng tốc Qualcomm Cloud AI 100. Hệ thống này, tối ưu hóa năng lượng và nhỏ gọn, cung cấp 70 nghìn tỷ phép tính mỗi giây (TOPS) với sức mạnh tính toán trí tuệ nhân tạo từ chip tăng tốc Cloud AI 100, được tối ưu hóa cho điện toán biên.",
      "Triển khai cùng với nền tảng di động Snapdragon 865, Gloria được thiết kế để hỗ trợ lên đến 24 camera FHD cho các ứng dụng phân tích video như phân tích lưu lượng và giải mã hình ảnh nhanh chóng.",
      "Các tùy chọn kết nối 5G Sub-6 và mmWave WAN có thể được áp dụng cho các ứng dụng khác nhau, dựa trên hệ thống Snapdragon X55 5G Modem-RF. Gloria được thiết kế để hỗ trợ trong các môi trường vận hành với nhiệt độ cao, cả trong nhà lẫn ngoài trời.",
    ],
    techInfor: [
      "Trong nhà/ngoài trời",
      "8MP/60fbs, H.264/H265",
      "Zoom quang 2x",
      "WDR 120dB, IR30m",
      "120dB",
      "IP66/IK10",
    ],
    techFeaturesId: [1, 2, 3, 4, 5, 6, 7, 8],
  },
]

export const techFeatures = [
  {
    id: 1,
    image: feature1,
    title: "Kiểm soát giao thông",
    description: [
      "Kiểm soát giao thông",
      "Phát hiện vi phạm",
      "Nhận diện biển số",
      "Đếm phương tiện, phân tích luồng giao thông",
      "Thống kê báo cáo, phân tích dữ liệu",
    ],
  },
  {
    id: 2,
    image: feature2,
    title: "Phát hiện bạo lực",
    description: [
      "Nhận diện đám đông",
      "Phát hiện bạo lực",
      "Phát hiện vũ khí",
    ],
  },
  {
    id: 3,
    image: feature3,
    title: "Phát hiện cháy",
    description: ["Phát hiện cháy, nổ, khói", "Cảnh báo kịp thời"],
  },
  {
    id: 4,
    image: feature4,
    title: "Nhận diện gương mặt",
    description: ["Nhận diện đối tượng", "Phân quyền đối tượng"],
  },
  {
    id: 5,
    image: feature5,
    title: "Cảnh báo an ninh",
    description: [
      "Cảnh báo đám đông tụ tập",
      "Cảnh báo bạo lực",
      "Đếm lượng người",
    ],
  },
  {
    id: 6,
    image: feature6,
    title: "Phát hiện xâm nhập",
    description: ["Cảnh báo người lạ"],
  },
  {
    id: 7,
    image: feature7,
    title: "Hệ thống chấm công",
    description: ["Nhận diện gương mặt", "Thống kê, báo cáo dữ liệu"],
  },
  {
    id: 8,
    image: feature8,
    title: "Giám sát tài sản",
    description: ["Phát hiện phá hoại tài sản", "Phát hiện đồ để quên"],
  },
]

export const productType = [
  {
    id: 1,
    name: "Camera",
  },
  {
    id: 2,
    name: "Bphone",
  },
  
]
